// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const luvdisc: PokeData = {
  "id": 370,
  "name": "luvdisc",
  "height": 6,
  "weight": 87,
  "base_experience": 116,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "water-gun",
    "hydro-pump",
    "agility",
    "flail",
    "sweet-kiss",
    "charm",
    "attract",
    "safeguard",
    "wish",
    "water-pulse",
    "brine",
    "lucky-chant",
    "aqua-ring",
    "captivate",
    "soak",
    "heart-stamp",
    "draining-kiss",
    "baby-doll-eyes",
    "tearful-look"
  ],
  "moves": [
    "tackle",
    "hydro-pump",
    "agility",
    "sweet-kiss",
    "brine",
    "aqua-tail",
    "bubble-beam",
    "aqua-cutter",
    "rain-dance",
    "whirlpool",
    "liquidation",
    "aqua-jet",
    "bubble"
  ],
  "evolution_chain": {
    "id": 190,
    "item": null,
    "species": [
      {
        "name": "luvdisc",
        "order": 400,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 194,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
